
    import React from 'react'
    import Base from '@ucheba/ui/components/Icon'
    import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js"
    import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js"

    const symbol = new SpriteSymbol({
  "id": "icon__unlock",
  "use": "icon__unlock-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon__unlock\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h16v16H0z\" /><path fill=\"currentColor\" d=\"M8 1a3.997 3.997 0 0 0-3.734 2.57c-.02.047-.04.094-.055.149l.95.312c.01-.031.023-.062.034-.097A3.003 3.003 0 0 1 8 2c1.664 0 3 1.336 3 3v2H3.5C2.676 7 2 7.676 2 8.5v5c0 .824.676 1.5 1.5 1.5h9c.824 0 1.5-.676 1.5-1.5v-5c0-.824-.676-1.5-1.5-1.5H12V5c0-2.203-1.797-4-4-4zM3.5 8h9c.281 0 .5.219.5.5v5c0 .281-.219.5-.5.5h-9a.494.494 0 0 1-.5-.5v-5c0-.281.219-.5.5-.5z\" /></g></symbol>"
})
    sprite.add(symbol)

    export default React.memo(function IconUnlockIcon(props) {
      const { className, ...restProps } = props
      return <Base.Icon className={className} id="icon__unlock" {...restProps} />
    })
  